import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Ornament } from "../components/Ornament";

/** Placeholder for the read-my-book page — reached from the "See my book so
 *  far" link on the Save Confirmation screen. Full print/PDF view will
 *  replace this in a later prompt. */
export default function MyBook() {
  return (
    <div className="min-h-screen paper" data-testid="my-book-placeholder">
      <header className="max-w-3xl mx-auto px-6 sm:px-10 py-8">
        <Link to="/my-living-book" className="inline-flex items-center gap-2 text-[#1B2A4A] hover:text-[#B8973A] transition-colors" style={{ minHeight: 44, fontFamily: "Georgia, serif", fontSize: "15px" }}>
          <ChevronLeft size={18} /> Back to My Living Book
        </Link>
      </header>
      <main className="max-w-xl mx-auto px-6 sm:px-10 pb-24 pt-8 text-center">
        <p className="label-ui text-[11px] text-[#B8973A] tracking-[0.35em]">MY BOOK</p>
        <h1 className="mt-4 text-4xl sm:text-5xl" style={{ fontFamily: "Cormorant Garamond, serif", fontWeight: 300, color: "#111D33", lineHeight: 1.15 }}>
          Your book, coming together.
        </h1>
        <Ornament className="my-8" />
        <p className="text-[#1B2A4A]" style={{ fontFamily: "Georgia, serif", fontSize: "18px", lineHeight: 1.7 }}>
          A quiet reading view of your seven chapters is on its way. For now you can review, edit and add to each day in your Living Book.
        </p>
        <div className="mt-8">
          <Link to="/my-living-book" className="btn-gold inline-flex items-center" style={{ minHeight: 52, padding: "14px 28px", fontSize: "13px", letterSpacing: "0.2em" }}>
            OPEN MY LIVING BOOK
          </Link>
        </div>
      </main>
    </div>
  );
}
